<template>
  <div class="social-networks">
    <ShareNetwork
    network="facebook"
    url=""
    :title="$t('redes.facebook')"
    >
      <iconFacebook />
    </ShareNetwork>
    
    <ShareNetwork
    network="twitter"
    url=""
    :title="$t('redes.twitter')"
    >
      <iconTwitter />
    </ShareNetwork>

    <ShareNetwork
    network="linkedin"
    url=""
    :title="$t('redes.linkedin')"
    >
      <iconLink />
    </ShareNetwork>   
   
    <ShareNetwork
    network="whatsapp"
    url=""
    :title="$t('redes.whatsapp')"
    >
      <iconWhatsapp />
    </ShareNetwork>

    <ShareNetwork
    network="telegram"
    url=""
    :title="$t('redes.telegram')"
    >
      <iconTelegram />
    </ShareNetwork>
  </div>
</template>

<style lang="scss">

  .social-networks {
    position: relative;
    z-index: 1;

    a {
      margin: 0 5px;
      padding: 5px 10px 5px 10px;
      border-radius: 50%;
      background: transparent;
      color: #000;
      display: inline-block !important;
    }
  }

</style>

<script>
  import iconFacebook from '@/components/iconos/iconFacebook.vue'
  import iconTwitter from '@/components/iconos/iconTwitter.vue'
  import iconLink from '@/components/iconos/iconLink.vue'
  import iconWhatsapp from '@/components/iconos/iconWhatsapp.vue'
  import iconTelegram from '@/components/iconos/iconTelegram.vue'

  export default {
    name: 'socialSharing',
    components: {
      iconFacebook,
      iconTwitter,
      iconWhatsapp,
      iconTelegram,
      iconLink
    }
  }
</script>